import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AdminDashboard from './components/AdminDashboard';
import LinkBuildingDashboard from './components/LinkBuildingDashboard';
import DigitalPRDashboard from './components/DigitalPRDashboard';
import LinkIntelligence from './components/LinkIntelligence';
import AILlmMentionsDashboard from './components/AILlmMentionsDashboard';
import Layout from './components/Layout';
import LoadingSpinner from './components/LoadingSpinner';

function App() {
  const { user, loading, canAccessAdmin, canAccessLinkIntelligence } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return <Login />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to={canAccessAdmin ? '/admin' : '/dashboard'} replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route
          path="/admin"
          element={canAccessAdmin ? <AdminDashboard /> : <Navigate to="/dashboard" replace />}
        />
        <Route
          path="/link-building"
          element={<LinkBuildingDashboard />}
        />
        <Route
          path="/digital-pr"
          element={<DigitalPRDashboard />}
        />
        <Route
          path="/ai-llm-mentions"
          element={canAccessAdmin ? <AILlmMentionsDashboard /> : <Navigate to="/dashboard" replace />}
        />
        <Route
          path="/link-intelligence/projects/:projectId/competitors/:competitorId"
          element={
            canAccessLinkIntelligence ? (
              <LinkIntelligence />
            ) : (
              <Navigate to="/dashboard" replace />
            )
          }
        />
        <Route
          path="/link-intelligence/projects/:projectId"
          element={
            canAccessLinkIntelligence ? (
              <LinkIntelligence />
            ) : (
              <Navigate to="/dashboard" replace />
            )
          }
        />
        <Route
          path="/link-intelligence/directory"
          element={
            canAccessLinkIntelligence ? (
              <LinkIntelligence />
            ) : (
              <Navigate to="/dashboard" replace />
            )
          }
        />
        <Route
          path="/link-intelligence"
          element={
            canAccessLinkIntelligence ? (
              <LinkIntelligence />
            ) : (
              <Navigate to="/dashboard" replace />
            )
          }
        />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  );
}

export default App; 